import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { PoListViewAction, PoModalAction, PoModalComponent, PoMultiselectOption, PoNotification, PoNotificationService, PoSelectOption, PoSelectOptionGroup, PoTableAction, PoTableColumn, PoTagType, PoUploadComponent } from '@po-ui/ng-components';
import { Subject, takeUntil } from 'rxjs';
import { saveAs } from 'file-saver';
import { MainService } from 'src/app/app.service';
import { Actions } from 'src/app/classes/Actions';
import { Database } from 'src/app/classes/Database';
import { Files } from 'src/app/classes/Files';
import { Recipes } from 'src/app/classes/Recipes';
import { Software } from 'src/app/classes/Software';
import { DatabaseService } from './database.service';
import { MatomoTracker } from '@ngx-matomo/tracker';
import { NotificationServiceHM } from '../notification-item/notification-item.service'
import { Region } from 'src/app/classes/Region';

@Component({
  selector: 'app-database',
  templateUrl: './database.component.html',
  styleUrls: ['./database.component.css']
})
export class DatabaseComponent implements OnInit {

  @ViewChild('criadb', {static: false}) criaDBModal: PoModalComponent;
  @ViewChild('deletDatabase', {static: false}) deleteDBModal: PoModalComponent;
  @ViewChild('renameDatabase', {static: false}) renameDBModal: PoModalComponent;
  @ViewChild('backupRestore', {static: false}) restoreModal: PoModalComponent;
  @ViewChild('historyModal', {static: false}) historyModal: PoModalComponent;
  @ViewChild('shareModal', {static: false}) shareModal: PoModalComponent;
  @ViewChild('changePassword', {static: false}) changePasswordModal: PoModalComponent;
  @ViewChild('uploadModal', {static: false}) uploadModal: PoModalComponent;
  @ViewChild('upload', {static: false}) upload: PoUploadComponent;

  loading = false;
  unsubscribe$ = new Subject<void>();

  activeOptions: Array<string> = [
    'created',
    'creating',
    'active',
    'deployed',
    'deploying',
    'expired',
    'expiring',
    'creating database',
    'deploying dbaccess',
    'backuping database',
    'restoring database',
    'restarting dbaccess',
    'deleting database',
    'deleting dbaccess'];

  deleteOptions: Array<string> = ['deleted', 'deleting', 'failed'];

  cannotModifyOptions: Array<string> = [
    'creating',
    'created',
    'deleting',
    'deleted',
    'failed',
    'creating database',
    'deploying dbaccess',
    'backuping database',
    'restoring database',
    'restarting dbaccess',
    'deleting database',
    'deleting dbaccess'];

  filterOptionsSelect: Array<any> = [
    { label: "Nome", value: "name"  },
    { label: "Status", value: "nStatus"  },
    { label: "Data de Criação", value: "createdAt"  },
    { label: "Expiração", value: "remainingTime"  },
  ]
  filterSelected: string = '';
  ascendingDescending: boolean = true;
  filterToggle: boolean = false;

  databases: any[] = [];
  databasesView: any[] = [];
  uploadItems: any[] = [];
  canUpload: boolean = false;
  backups: any[] = [];
  chosenBackup: string = '';

  // - NOTIFICATIONS
    message: string = '';
    poNotification: PoNotification = {
      message: this.message,
      action: undefined
    };

  // - VARIAVEIS BASE
  _id: string = '';
  _name: string = '';
  _status: string = '';
  _statusType: string = '';
  _remainingTime: number = 0;
  _expirationDate: string = '';
  _username: string = '';
  _area: string = '';
  _nStatus: number = 0;
  _login: string = '';
  _softwareType: string = '';
  _owner: string = '';
  _shared: string[] = [''];
  _metadata: object = {};
  _alias: string = '';
  _dbipporta: string = '';
  _dbaccess: string = '';
  _instanceType: string = '';
  _kind: string = '';

  // - UPLOAD
  selectedFile: Array<any> = [];
  uploadColumns: Array<PoTableColumn> = [];
  uploadActions: Array<PoTableAction> = [
    { action: this.downloadFile.bind(this), label: 'Download' },
    { action: this.deleteFile.bind(this), label: 'Delete' }
  ];

  sendUpload: PoModalAction = {
    action: () => {
      this.sendFiles();
    },
    label: 'Enviar'
  };

  cancelUpload: PoModalAction = {
    action: () => {
      this.loading = false;
      this.getFiles();
      this.uploadModal.close();
    },
    label: 'Cancelar'
  };


  //- CRIAÇÃO DE DATABASE

  dbCreate: PoModalAction = {
    action: () => {
      if (!this.validForm()) {
        this.notificationServiceHM.showToast("Preencha todos os campos!", 'warning');
        return;
      }
      this.createDatabase();
    },
    label: 'Criar',
  };

  cancelCreate: PoModalAction = {
    action: () => {
      this.criaDBModal.close();
    },
    label: 'Cancelar'
  };

  receitas: Array<any> = []
  receitasBackups: Array<any> = []
  receitasFiltered: Array<PoSelectOptionGroup|PoSelectOption> = [];
  receitaID: string = '';
  recEscolhida: any = undefined;
  software:Array<any> = [];
  softwareSelected: string = '';
  expiraNew: number = 0;
  expiraOptions: Array<any> = [
    { label: '20 dias', value: 20 },
    { label: '40 dias', value: 40 }
  ];

  // - DELETE DATABASE

  toDelete: Database;
  canDelete: string = "NO";
  okDelete: PoModalAction = {
    action: () => {
      if (this.canDelete === "YES") {
        this.deleteDatabase();
      } else {
        this.notificationServiceHM.showToast(`Operação de delete cancelada!`, 'warning');
      }
      this.deleteDBModal.close();
      this.canDelete = "NO";
    },
    label: 'Confirmar'
  };

  // - SHARE - //
  toShare: Database;
  databseIdToShare = '';
  usersSelected: Array<any> = [];
  usersInArea: Array<any> = [];

  getUpdateSharedData(event: { usersSelected: Array<any>}){
    this.usersSelected = event.usersSelected;
  }

  okShare: PoModalAction = {
    action: () => {
        this.shareDatabase();
        this.shareModal.close();
    },
    label: 'Compartilhar'
  };

  cancelShare: PoModalAction = {
    action: () => {
      this.loading = false;
      this.shareModal.close();
    },
    label: "Cancelar"
  };

  // - CHANGE PASSWORD - //
  passwordNew: string = '';
  changePasswordDatabaseID: string = '';

  okChangePassword: PoModalAction = {
    action: () => {
        this.changePasswordDatabase();
        this.loading = false;
        this.changePasswordModal.close();
    },
    label: 'Trocar'
  };

  cancelChangePassword: PoModalAction = {
    action: () => {
      this.loading = false;
      this.changePasswordModal.close();
    },
    label: "Cancelar"
  };

  // - EDIÇÃO E OUTRAS MUDANÇAS

  modificaDatabase: PoModalAction = {
    action: () => {
      setTimeout(() => {
        this.modificaDB();
        this.renameDBModal.close();
      }, 500)

    },
    label: 'Alterar'
  };

  toRestore: Database;

  okRestore: PoModalAction = {
    action: () => {
        this.restoreDatabase();
        this.loading = false;
        this.restoreModal.close();
    },
    label: 'Restaurar'
  };

  cancelRestore: PoModalAction = {
    action: () => {
      this.loading = false;
      this.restoreModal.close();
    },
    label: "Cancelar"
  };

  history: Array<any> = [ ];
  titleDetailsModal: string = '';
  columnsDetails = [
    { property: 'actionType', label: 'Açao', type: 'string' },
    { property: 'username', label: 'Username', type: 'string' },
    { property: 'description', label: 'Descrição', type: 'string' },
    { property: 'createdAt', label: 'Created at', type: 'string' },
    { property: 'updatedAt', label: 'Updated at', type: 'string' }
  ];

  okHistory: PoModalAction = {
    action: () => {
        this.loading = false;
        this.historyModal.close();
    },
    label: 'Cancelar'
  };

  // - OPÇÕES DE CADA RESOURCE - //
  itemListOptions: Array<PoListViewAction> = [
    { label: 'Prorrogar / Renomear', action: this.alterarDB.bind(this), disabled: this.cannotExtendExpiration.bind(this)},
    { label: 'Reiniciar DbAccess', action: this.restartDbAccess.bind(this), disabled: this.cannotRestart.bind(this)},
    { label: 'Histórico', action: this.databaseHistory.bind(this) },
    { label: 'Realizar Backup', action: this.backupDatabase.bind(this), disabled: this.cannotBackup.bind(this) },
    { label: 'Restaurar Backup', action: this.backupRestore.bind(this), disabled: this.cannotBackup.bind(this) },
    { label: 'Trocar Senha', action: this.changePassword.bind(this), disabled: this.cannotChangePassword.bind(this) },
    { label: 'Compartilhar', action: this.shareResource.bind(this), disabled: this.cannotShare.bind(this) },
    { label: 'Excluir', action: this.shouldDelete.bind(this), disabled: this.cannotDelete.bind(this) }
  ];

  constructor(
    @Inject(LOCALE_ID)
    public locale: string,
    public mainService: MainService,
    private databaseService: DatabaseService,
    public poNotificationService: PoNotificationService,
    public notificationServiceHM: NotificationServiceHM,
    private readonly tracker: MatomoTracker) { }

  ngOnInit(): void {
    this.tracker.trackPageView('Database');
    this.getDatabases();
    this.getFiles();
    this.getRegions();
    this.getReceitas();
  }

  updateScreenData(){
    this.getDatabases();
    this.getFiles();
  }

  getDatabases(){
    this.loading = true;
    this.databases = [];
    this.databasesView = [];
    this.databaseService.getDatabases()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
              next: ((response) => {
                response.forEach(element => {
                  const databaseTemp = new Database();
                  databaseTemp.id = element.id;
                  databaseTemp.name = element.name;
                  databaseTemp.expirationDate = element.expirationDate.split('T', 1);

                  let remainingTime = element.expirationDate;
                  remainingTime = new Date(remainingTime).valueOf() - new Date().valueOf();
                  databaseTemp.remainingTime = Math.floor(remainingTime/ (1000 * 3600 * 24));

                  databaseTemp.status = element.status || element.deployStats;

                  if (element.deployStatsData !== undefined && element.deployStatsData.hasOwnProperty('message')) {
                    databaseTemp.deployStatsDataResume = databaseTemp.status + ' - ' + element.deployStatsData['message'];
                  } else {
                    databaseTemp.deployStatsDataResume = databaseTemp.status;
                  }

                  switch ( databaseTemp.status.toLowerCase() ) {
                    case 'failed':
                      databaseTemp.statusType = PoTagType.Danger;
                      databaseTemp.nStatus = 1;
                      databaseTemp.active = false;
                      break;

                    case 'deploying':
                    case 'expiring':
                    case 'creating':
                    case 'backuping database':
                    case 'restoring database':
                    case 'restarting dbaccess':
                    case 'creating database':
                    case 'deploying dbaccess':
                      databaseTemp.statusType = PoTagType.Warning;
                      databaseTemp.nStatus = 2;
                      databaseTemp.active = true;
                      break;

                    case 'expired':
                      databaseTemp.statusType = PoTagType.Danger;
                      databaseTemp.nStatus = 3;
                      databaseTemp.active = false;
                      break;

                    case 'active':
                    case 'deployed':
                      databaseTemp.statusType = PoTagType.Success;
                      databaseTemp.nStatus = 4;
                      databaseTemp.active = true;
                      break;

                    case 'deleting':
                    case 'deleting database':
                    case 'deleting dbaccess':
                      databaseTemp.statusType = PoTagType.Warning;
                      databaseTemp.nStatus = 5;
                      databaseTemp.active = false;
                      break;

                    case 'deleted':
                      databaseTemp.statusType = PoTagType.Info;
                      databaseTemp.nStatus = 6;
                      databaseTemp.active = false;
                      break;

                  };

                  databaseTemp.username = element.login || element.username;

                  if (element.metadata) {
                    databaseTemp.metadata = element.metadata;
                    databaseTemp.dbipporta = `${element.metadata.host}:${element.metadata.port}`;
                    databaseTemp.username = element.metadata.user;
                    databaseTemp.password = element.metadata.pass;
                    databaseTemp.instanceType = element.metadata.type;
                    databaseTemp.visualPassword = '*****';

                    if (element.metadata.artifacts) {
                      for (let item of element.metadata.artifacts) {
                        if (item.name.toLowerCase() === 'dbaccess') {
                          databaseTemp.dbaccess = `${item.ip}:${item.port}`;
                        }
                      }
                    }
                  }

                  if (databaseTemp.instanceType === 'PROTHEUS') {
                    databaseTemp.name += ' - PROTHEUSDB'
                    databaseTemp.dbaccess = "Verificar menu Protheus"
                  }

                  databaseTemp.softwareType = element.softwareType;
                  databaseTemp.alias = element.softwareType;

                  databaseTemp.shared = element.shared;
                  databaseTemp.owner = element.username;

                  /// REGRA PARA MIGRAÇÃO R22
                  databaseTemp.spotId = element.spotId || "";
                  databaseTemp.kind = element.kind;

                  databaseTemp.createdAt = element.createdAt.split('T', 1);
                  databaseTemp.updatedAt = element.updatedAt.split('T', 1);

                  if ( this.activeOptions.includes(databaseTemp.status)){
                    this.databasesView = [...this.databasesView, databaseTemp];
                  }
                  this.databases = [...this.databases, databaseTemp];
                });
                this.loading = false;
              }),
              error: ((msgError) => {
                this.mainService.handleError(msgError);
                this.loading = false;
              })},
      );
  }

  getRegions(){
    this.loading = true;
    this.databaseService.getRegions()
      .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((response) => {
            response.forEach(element => {
              const regionTemp = new Region();

              regionTemp.id = element._id || element.id;
              regionTemp.name = element.name;
              regionTemp.label = element.displayName;
              regionTemp.value = element._id || element.id;
              regionTemp.workers = element.workers;
              regionTemp.roles = element.roles;
              this.regions = [...this.regions, regionTemp];
            });

            if (this.regions.length === 1) {
              this.regionSelectedId = this.regions[0].value;
              this.onChangeRegion(this.regions[0].id);
            }
            this.loading = false;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });
  }

  getReceitas() {
    this.receitas = [];
    this.loading = true;
    this.databaseService.getRecipes()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: ((response) => {
        response.forEach(element => {
          const receitasTemp = new Recipes();
          receitasTemp.id = element.id;
          if (element._id) receitasTemp.id = element._id;
          receitasTemp.name = element.name;
          receitasTemp.preset = element.preset;
          receitasTemp.softwareId = element.softwareId;
          receitasTemp.version = element.version;
          receitasTemp.presetVersion = element.presetVersion;
          receitasTemp.value = element.id;
          let version = element.presetVersion === '-' ? '' : ` - ${element.presetVersion}`;
          let label = element.displayName ?? element.name;
          receitasTemp.label = label;
          receitasTemp.value = receitasTemp.id;

          receitasTemp.kind = element.kind;
          receitasTemp.language = element.language;
          receitasTemp.locale = element.locale;
          receitasTemp.release = element.release;
          receitasTemp.softwareType = element.softwareType;
          receitasTemp.url = element.url;
          this.receitas = [...this.receitas, receitasTemp];
        });

        this.receitas.sort((a, b) => {
          if (a['label'] < b['label']) {
            return this.ascendingDescending ? -1 : 1;
          }
          if (a['label'] > b['label']) {
            return this.ascendingDescending ? 1 : -1;
          }
          return 0;
        });

        this.loading = false;
      }),
      error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
      })
    });
  }

  getFiles() {
    let uploadExtension = [];
    this.uploadItems = [];
    this.receitasBackups = [];
    this.canUpload = true;
    this.loading = true;
    this.databaseService.getFiles()
    .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((response) => {
            response.forEach(element => {
              const uploadTemp = new Files();

                uploadTemp.name = element.name;
                uploadExtension = element.name.split('.');
                uploadTemp.extension = uploadExtension[uploadExtension.length - 1];
                uploadTemp.lastModified = element.lastModified.split('T', 1);
                uploadTemp.size = (element.size / 1000);

                this.uploadItems = [...this.uploadItems, uploadTemp];
                if ( this.mainService.userToken.role === 'superuser' ) {
                  this.canUpload = true;
                } else {
                  this.canUpload = ( this.uploadItems.length >= 4 ) ? false : true;
                }

                // Adiciona no combo de templates / receitas os backups atuais para restore
                const receitasTemp = new Recipes();
                receitasTemp.id = element.name;
                receitasTemp.name = element.name;
                receitasTemp.value = element.name;
                receitasTemp.label = element.name;
                receitasTemp.kind = "backup";
                this.receitasBackups.push(receitasTemp);
            });

            this.receitasBackups.sort((a, b) => {
              if (a['label'] < b['label']) {
                return this.ascendingDescending ? -1 : 1;
              }
              if (a['label'] > b['label']) {
                return this.ascendingDescending ? 1 : -1;
              }
              return 0;
            });

            this.loading = false;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });
  }

  toggleFilters() {

   this.filterToggle = !this.filterToggle;
  }

  filteredData(event: Array<any>){
    this.databasesView = event;
  }

  filterRecipeItem(id: string) {
    let filtered = this.receitas.filter(x => x.id == id);
    if (filtered.length < 1) filtered = this.receitasBackups.filter(x => x.id == id);
    if (filtered.length < 1) return 'NOT FOUND';
    else return filtered[0];
  }

  onChangeRecipe(recipe) {
    this.resetFields('recipe');
    let recipeFull = this.filterRecipeItem(recipe);
    this.recEscolhida = recipeFull;
    this.pushTagsValues(this.softwareSelected, false);
  }

  filterBackups (filter: Database|Recipes) {
    this.backups = [];

    const softwareType = filter.softwareType.toLowerCase();
    this.backups = this.uploadItems.filter(upload => upload.name.includes(`${softwareType}.zip`));

    this.backups = this.backups.map(upload => {
      return {label: upload.name, value: upload.name};
    });
  }

  validForm() {
    let validRestore: boolean = true;
    if (this.recEscolhida.preset === 'restore') {
      this.chosenBackup === '' ? validRestore = false : validRestore = true
    }
    return !!this.recEscolhida && !!this._name && validRestore;
  }

  generatePassword() {
      let password = "";
      const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 8; i++)
      password += possible.charAt(Math.floor(Math.random() * possible.length));

      return password;
  }

  createDatabase() {
    let finaldate = 7;
    this.loading = true;

    const region_id = this.regionSelected?.id
    const tags = this._tagsSelected.map(e1 => e1.value);

    if (this.recEscolhida.kind === "template") {
      this.databaseService.createDatabase2(this._name, this.recEscolhida.id, undefined, region_id, tags).pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe({
        next: ((response) => {
          // this.poNotification.message = "Database " + name + " em processo de criação!"
          // this.poNotificationService.success(this.poNotification)
          this.notificationServiceHM.showToast("Database " + this._name + " em processo de criação!", 'success')
          this.loading = false;
        }),
        error: ((msgError) => {
          this.mainService.handleError(msgError);
          this.loading = false;
        })
       });
    } else if (this.recEscolhida.kind === "backup") {
      this.databaseService.createDatabase2(this._name, this.recEscolhida.id, this.recEscolhida.id, region_id, tags).pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe({
        next: ((response) => {
          // this.poNotification.message = "Database " + name + " em processo de criação!"
          // this.poNotificationService.success(this.poNotification)
          this.notificationServiceHM.showToast("Database " + this._name + " em processo de criação!", 'success')
          this.loading = false;
        }),
        error: ((msgError) => {
          this.mainService.handleError(msgError);
          this.loading = false;
        })
       });
    }

    this.criaDBModal.close();
    this.getDatabases();
  }


  cannotDelete(instanciaSelect): boolean {

    if (instanciaSelect.owner !== this.mainService.userToken.username) {
      return true;
    }
    if (instanciaSelect.instanceType === 'PROTHEUS') {
      return true;
    }

    return this.cannotModifyOptions.includes(instanciaSelect['status'].toLowerCase());
  }

  shouldDelete(databaseSelect) {
    this.toDelete = databaseSelect;
    this.deleteDBModal.open();
  }

  deleteDatabase() {
    this.loading = true;

    this.databaseService.deleteDatabase2(this.toDelete.id)
    .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((response) => {
        // this.poNotification.message = "Database " + response.name + " em processo de deleção!";
        // this.poNotificationService.success(this.poNotification);
        this.notificationServiceHM.showToast("Database " + response.name + " em processo de deleção!", 'success')
        this.getDatabases();
        }),
        error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
        })
      });
    this.deleteDBModal.close();
  }

  alterarDB(databaseSelect) {
    this._name = databaseSelect['name'];
    this._id = databaseSelect['id'];
    this._kind = databaseSelect["kind"];
    this.expiraNew = 0;
    this.renameDBModal.open();
  }

  getUpdateData(event: { _name: string, _expirationDays: number}){
    this._name = event._name;
    this.expiraNew = event._expirationDays
  }

  modificaDB() {
    const toChange = this.databasesView.find((i) => i.id === this._id);
    this.loading = true;

    this.databaseService.alterarDatabase2(this._id, this._name, this.expiraNew)
    .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((response) => {
        this.getDatabases();
        }),
        error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
        })
      });
  }

  cannotExtendExpiration(databaseSelect): boolean {
    if ( this.mainService.userToken.role === 'team')  return true;
    if (databaseSelect.instanceType === "PROTHEUS") return true;

    return !(this.activeOptions.includes(databaseSelect['status'].toLowerCase()));
  }

  restartDbAccess(databaseSelected) {
    this.loading = true;

    this.databaseService.restartDbAccess2(databaseSelected.id)
    .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((response) => {
        // this.poNotification.message = "Dbaccess da base " + databaseSelected['name'] + " está sendo reiniciado"
        // this.poNotificationService.success(this.poNotification)
        this.notificationServiceHM.showToast("Dbaccess da base " + databaseSelected['name'] + " está sendo reiniciado", 'success')
        this.loading = false;
        }),
        error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
        })
    });
  }

  cannotBackup(instanciaSelect): boolean {
    if (
      instanciaSelect.owner !== this.mainService.userToken.username
      &&
      !instanciaSelect.shared.includes(this.mainService.userToken.username)
    ) {
      return true;
    }
    if ( this.mainService.userToken.role === 'team') {
        return true;
    }

      return this.cannotModifyOptions.includes(instanciaSelect['status'].toLowerCase());
  }

  backupDatabase(databaseSelected) {
    this.loading = true;

    this.databaseService.backupDatabase2(databaseSelected.id)
    .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((response) => {
        // this.poNotification.message = "Backup do database " + databaseSelected.name + " iniciado com sucesso!"
        // this.poNotificationService.success(this.poNotification)
        this.notificationServiceHM.showToast("Backup do database " + databaseSelected.name + " iniciado com sucesso!", 'success');
        this.loading = false;
        }),
        error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
        })
      });
  }

  backupRestore(databaseSelected) {
    this.toRestore = databaseSelected;
    this.filterBackups(databaseSelected);
    this.chosenBackup = '';
    this.restoreModal.open();
  }

  restoreDatabase() {
    this.loading = true;

    const databaseId = this.toRestore.id;
    const filename = this.chosenBackup;

    if (filename === "") {
      this.notificationServiceHM.showToast('Operação cancelada, backup não foi selecionado', 'warning');
      this.restoreModal.close();
      return;
    }

    this.databaseService.restoreDatabase2(databaseId, filename)
    .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        // this.poNotification.message = "Restauração iniciada com sucesso!"
        // this.poNotificationService.success(this.poNotification);
        this.notificationServiceHM.showToast("Restauração iniciada com sucesso!", 'success');
        this.getDatabases();
      });

    this.restoreModal.close();
  }

  cannotShare(instanciaSelect): boolean {
    if ( instanciaSelect.owner !== this.mainService.userToken.username) {
      return true;
    }

    if (instanciaSelect.instanceType === 'PROTHEUS') {
      return true;
    }

    return false;
  }

  shareResource(instanciaSelect) {
    this.usersInArea = [];
    this.toShare = instanciaSelect;
    this.databseIdToShare = instanciaSelect['id'];
    this.usersSelected = instanciaSelect['shared'];

    let usersUpdated = this.usersSelected.map(user => {
      return {label: user, value: user}}
    );
    this.usersInArea = usersUpdated;
    this.shareModal.open();
  }

  shareDatabase() {
    this.loading = true;
    this.databaseService.shareDatabase2(this.databseIdToShare, this.usersSelected)
      .subscribe(res => {
        this.notificationServiceHM.showToast('Database ' + res.name + ' compartilhada com sucesso', 'success')
        this.loading = false;
      });

    this.getDatabases();
  }

  cannotChangePassword(databaseSelected): boolean {
    if ( databaseSelected.owner !== this.mainService.userToken.username) return true;
    if (databaseSelected.instanceType === "PROTHEUS") return true;

    return this.cannotModifyOptions.includes(databaseSelected['status'].toLowerCase());
  }

  cannotRestart(instanciaSelect): boolean {
    if (this.cannotModifyOptions.includes(instanciaSelect['status'].toLowerCase()))
	return true;

    if (instanciaSelect.instanceType === "PROTHEUS")
	return true;

    return false;
  }

  changePassword(databaseSelected) {
    this.changePasswordDatabaseID = databaseSelected['id'];
    this.changePasswordModal.open();
  }

  changePasswordDatabase() {
    this.loading = true;
    const database = this.databases.filter(e => e.id === this.changePasswordDatabaseID);

     this.databaseService.changePasswordDatabase2(this.changePasswordDatabaseID, this.passwordNew)
     .subscribe({
      next: (res => {
        this.getDatabases();
        this.loading = false;
      }),
      error: ((msgError) => {
        this.mainService.handleError(msgError);
        this.loading = false;
      })
    });

    this.changePasswordModal.close();
  }

  databaseHistory(databaseSelected) {
    this.history = [ ];
    this.loading = true;
    this.databaseService.getActionsbyResource(databaseSelected['id'])
        .subscribe({
          next: ((response) => {
            response.forEach(element => {

              const historyTemp = new Actions();
              historyTemp.Id = element.id;
              historyTemp.resourceId = element.resourceId;
              historyTemp.recipeId = element.recipeId;
              historyTemp.actionType = element.actionType;
              historyTemp.username = element.username;
              historyTemp.description = element.description;
              historyTemp.createdAt = element.createdAt.replace('T', ' - ').split('.', 1);
              historyTemp.updatedAt = element.updatedAt.replace('T', ' - ').split('.', 1);

              this.history = [...this.history, historyTemp];
            });
            this.loading = false;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });
      this.titleDetailsModal = databaseSelected['name'];
      this.historyModal.open();
  }

  resetValuesUpload() {
    this.selectedFile = [];
    if ( this.mainService.userToken.role === 'superuser') {
      this.canUpload = true;
    }
  }

  resetFields(from: 'region' | 'software' | 'recipe') {
    const p = { region: 0, software: 1, recipe: 2 }[from];

    if (p <= 0) {
      this.softwareSelected = '';
    }
    if (p <= 1) {
      this.receitaID = '';
      this.recEscolhida = undefined;
      this.receitasFiltered = [];
    }
    this.resetTagsValues();
    if (this.regionSelected) {
      this.pushTagsValues(this.regionSelected.name, false);
    }
  }

  resetValuesCriaDb() {
    this.regionSelected = undefined;
    this.regionSelectedId = '';
    this.chosenBackup = '';
    this._allWorkers = [];
    this._workers = [];
    this._tags = [];
    this.resetFields('region');
    if (this.regions.length === 1) {
      this.regionSelectedId = this.regions[0].value;
      this.onChangeRegion(this.regions[0].id);
    }
  }

  resumeUploadError() {

    this.mainService.handleError(this.selectedFile[0]);
    // this.poNotificationService.error('Falha ao realizar o upload!');
    this.notificationServiceHM.showToast('Falha ao realizar o upload!', 'error')
    this.getFiles();
    this.loading = false;
  }

  resumeUploadSuccess() {
    this.loading = false;
    // this.poNotificationService.success('Upload realizado com sucesso!');
    this.notificationServiceHM.showToast('Upload realizado com sucesso!', 'success');
    this.getFiles();
    this.uploadModal.close();
  }

  sendFiles() {

    this.loading = true;
    // this.poNotificationService.success('Upload iniciado...');
    this.notificationServiceHM.showToast('Upload iniciado...', 'success')
    this.databaseService.uploadImage(this.selectedFile[0].rawFile, this.selectedFile[0].name ).subscribe(
            (res) => {
              this.resumeUploadSuccess();
            },
            (err) => {
              this.resumeUploadError();
            });
  }

  deleteFile(fileSelected) {
    this.loading = true;
    this.databaseService.deleteFile(fileSelected['name'])
      .subscribe(res => {
        this.getFiles();
        this.loading = false;
      });
      this.uploadModal.close();
      this.uploadModal.open();
  }

  downloadFile(fileSelected) {
    this.loading = true;
    this.databaseService.downloadFile(fileSelected['name'])
      .subscribe(res => {

        saveAs(res.url, fileSelected['name']);

        this.getFiles();
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

// AQUI

  regions: Array<Region> = [];
  regionSelected?: Region;
  regionSelectedId: string = '';

  tagSelection?: string = '';
  tagSelectionOptions: Array<PoSelectOption> = [];

  _allWorkers:Array<any> = [];
  _workers:Array<any> = [];
  _tags:Array<any> = [];
  _tagsSelected:Array<any> = [];

  updateComponents() {
    let temp1 = {};
    for (let tag of this._tags) {
      let {value, label, group} = tag;
      if (!(group in temp1))
        temp1[group] = {label: group, options: [{label, value}]}
      temp1[group].options.push({label, value})
    }
    this.tagSelection = '';
    this.tagSelectionOptions = Object.values(temp1);
  }

  updateComponentsStructures() {
    this._workers = this.filterWorkersByTags(this._allWorkers, this._tagsSelected);
    this._tags = this.getWorkersTags(this._workers);
    this._tags = this._tags.filter(e1 => !(this._tagsSelected.find(e2 => e2.value === e1.value)));
  }

  pushTagsValues(value:string, removable:boolean) {
    if (this._tagsSelected.find(e1 => e1.value === value))
      return;

    let tempTag = this._tags.find(e1 => e1.value === value);
    if (!tempTag) return;

    tempTag.removable = removable;
    this._tagsSelected.push(tempTag);

    this.updateComponentsStructures();
    this.updateComponents();
  }

  removeTagsValues(value: string) {
    this._tagsSelected = this._tagsSelected.filter(e1 => e1.value !== value);

    this.updateComponentsStructures();
    this.updateComponents();
  }

  resetTagsValues() {
    this._tagsSelected = [];
    this.updateComponentsStructures();
    this.updateComponents();
  }
 
  getWorkers(region:Region, type:string) {
    if (!region.workers) return [];
    return region.workers.filter(e => e.type === type);
  }

  getWorkersTags(workers:any) {
    let tags:any = [];
    for (let worker of workers) {
      for (let tag of worker.tags) {
        if (tags.find(e => e.value === tag.value))
          continue;
        tags.push(tag);
      }
    }
    return tags;
  }

  filterWorkersByTags(workers:any, tags:any) {
    let remove:any = [];
    for (let worker of workers) {
      for (let tag of tags) {
        if (!worker.tags.find(e => e.value === tag.value)) {
          remove.push(worker);
          break;
        }
      }
    }
    return workers.filter(e1 => !remove.find(e2 => e2.name === e1.name));
  }

  onChangeRegion(element) {
    this.regionSelected = this.regions.find(e => e.id === element)!;

    this._allWorkers = this.getWorkers(this.regionSelected, "database");
    this._workers = this._allWorkers;
    this._tags = this.getWorkersTags(this._workers);

    let softwares:Array<Software> = [];
    for (let tag of this._tags) {
      if (tag.field === 'database') {
        let software = new Software();
        software.label = tag.label;
        software.value = tag.value;
        softwares.push(software);
      }
    }

    if (softwares.length > 0) {
      this.software = softwares;
    }

    this.resetFields('region');
  }

  onChangeSoftware(element) {
    this.resetFields('software');

    this.receitasFiltered = [
      { label: "Meus Backups",
        options: this.receitasBackups.filter(x => x.name.endsWith(`.${element.toLowerCase()}.zip`))
      },
      {
        label: "Receitas",
        options: this.receitas.filter(x => x.softwareType.toLowerCase() === element.toLowerCase())
      }
    ];

    this.pushTagsValues(element, false);
  }

  onChangeTagSelection(feature) {
    this.pushTagsValues(this.tagSelection!, true);
    this.tagSelection = undefined;
  }

  onRemoveTag(feature) {
    this.removeTagsValues(feature.value);
  }

  get showRegionSelect(): boolean {
    return this.regions.length > 1;
  }

  get disableSoftware(): boolean {
    return !this.regionSelected;
  }

  get disableRecipe(): boolean {
    return !this.softwareSelected;
  }

  get disableTagSelection() {
    return !this.receitaID;
  }

  hideTags() {
    return this._tagsSelected.length >0 || this._tags.length > 0
  }
}
